import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { buyerFavoritesSummariesQueryDefinition } from 'dpl/buyer_account/utils/resourceDefinitions';

export default function useBuyerFavoritesSummaries(buyerProfileId: any) {
  const summariesData = useResourceQuery({
    ...buyerFavoritesSummariesQueryDefinition(buyerProfileId),
    enabled: Boolean(buyerProfileId)
  });

  async function refetchAndCheckHasTwoFavorites() {
    const result = await summariesData.refetch();
    const updatedTotal =
      (result?.data?.data?.meta?.total_puppies_count ?? 0) +
      (result?.data?.data?.meta?.total_breeders_count ?? 0);
    return updatedTotal === 2;
  }

  return {
    summariesData,
    refetchAndCheckHasTwoFavorites,
    isLoadingFavoritesSummaries: summariesData.isLoading
  };
}
